const styles = {
  flex: { flex: 1 },
  backgroundColor: 'transparent !important',
  appHeader: { position: 'relative', marginTop: 0, backgroundColor: 'transparent !important' },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/flights/passengerCounters/PassengerCountersHeaderStyles.js